import UniqueJob from "../components/UniqueJob/UniqueJob";

const UniqueJobPage = () => {
  return <UniqueJob />;
};

export default UniqueJobPage;
